import { Box, Paper, Typography } from '@mui/material';
import styled from 'styled-components';

export const StyledOverview = styled.div``;
export const StyledTypo = styled(Typography)`
  margin-left: 100px;
`;

export const StyledPaper = styled(Paper)`
  padding: 24px;
  margin: 24px;
`;
export const StyledBox = styled(Box)`
  display: flex;
  justify-content: center;
`;
